export const PaymentsAdjJSONSchema = {
  type: 'object',
  properties: {
    pointDeducted: {
      type: 'string',
      description: 'OD',
    },
    totalPoints: {
      type: 'string',
    },
    topUpPaymentAmount: {
      type: 'string',
    },
    totalDepositAmount: {
      type: 'string',
    },
  },
}

export const PaymentsAdjJSONUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/pointDeducted',
          component: 'ReadOnlyFieldWithJson',
          label: 'Point Deducted',
        },
        {
          type: 'Control',
          scope: '#/properties/totalPoints',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Points',
        },
        {
          type: 'Control',
          scope: '#/properties/topUpPaymentAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Top Up Payment Amount',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/totalDepositAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Deposit Amount',
        },
      ],
    },
  ],
}
